<template>
	<div id="map_container">
		<!-- <v-overlay opacity="0.5" z-index="1" absolute>
        <v-progress-circular
          indeterminate
          color="primary"
          size="150"
          width="10"
        ></v-progress-circular>
		</v-overlay>-->
		<div v-if="!noEdit" class="map-toolbar">
			<v-btn
				small
				color="primary"
				:outlined="drawingMode !== 'polygon'"
				@click.stop="startPolygon"
			>
				<v-icon left small>mdi-vector-polygon</v-icon>
				Dibujar cubierta
			</v-btn>
			<v-btn
				small
				color="secondary"
				:outlined="drawingMode !== 'marker'"
				@click.stop="startMarker"
			>
				<v-icon left small>mdi-map-marker</v-icon>
				Marcar suministro
			</v-btn>
			<v-btn
				small
				color="success"
				:disabled="draftPath.length < 3"
				@click.stop="completePolygon"
			>
				<v-icon left small>mdi-check</v-icon>
				Finalizar
			</v-btn>
			<v-btn
				small
				icon
				:disabled="!drawingMode && draftPath.length === 0"
				@click.stop="cancelDrawing"
			>
				<v-icon small>mdi-close</v-icon>
			</v-btn>
		</div>
		<div id="map"></div>
	</div>
</template>

<script>
import { init } from "@/utils/gmaps.js";
import chroma from "chroma-js";

export default {
	props: {
		center: { type: Object, default: { lat: 40.4165, lng: -3.70256 } },
		zoom: Number,
		value: Array,
		marker: Boolean,
		noEdit: Boolean,
	},
	data() {
		return {
			google: null,
			map: null,
			drawingMode: null,
			draftPath: [],
			draftPolygon: null,
			activeColor: null,
			prevMarker: null,
			mapClickListener: null,
			mapMouseMoveListener: null,
			// cubiertas: JSON.parse(JSON.stringify(this.cub)),
		};
	},
	computed: {
		cubiertas() {
			return this.value;
		},
	},
	async mounted() {
		if (this.google == null) {
			this.google = await init();
		}
		await this.$nextTick();
		const map = new this.google.maps.Map(this.$el.querySelector('#map'), {
			center: this.center,
			zoom: this.zoom,
			mapTypeId: "hybrid",
		});
		this.map = map;
		this.map.setTilt(0);

		if (this.marker) {
			this.prevMarker = new this.google.maps.Marker({
				position: this.center,
				map: this.map,
				title: "Marcardor suministro",
			});
		}
		this.cubiertas.splice(0, 0);

		if (this.noEdit) return;
		this.mapClickListener = this.map.addListener("click", this.onMapClick);
		this.mapMouseMoveListener = this.map.addListener("mousemove", this.onMapMouseMove);
		this.startPolygon();
	},
	beforeDestroy() {
		this.cancelDrawing();
		if (this.mapClickListener) this.google.maps.event.removeListener(this.mapClickListener);
		if (this.mapMouseMoveListener) this.google.maps.event.removeListener(this.mapMouseMoveListener);
	},
	methods: {
		panTo(coord) {
			this.map.panTo(coord)
		},
		async buscarDireccion(dir) {
			const geocoder = new this.google.maps.Geocoder();
			let coords = await geocoder.geocode({ address: dir })
			coords = coords.results[0].geometry.location
			return { lat: coords.lat(), lng: coords.lng() }
		},
		startPolygon() {
			this.cancelDrawing(false);
			this.drawingMode = "polygon";
			this.activeColor = chroma.random().toString();
			if (this.map) {
				this.map.setOptions({
					draggableCursor: "crosshair",
					disableDoubleClickZoom: true,
				});
			}
		},
		startMarker() {
			this.cancelDrawing(false);
			this.drawingMode = "marker";
			if (this.map) {
				this.map.setOptions({
					draggableCursor: "crosshair",
					disableDoubleClickZoom: false,
				});
			}
		},
		cancelDrawing(clearMode = true) {
			this.draftPath = [];
			if (this.draftPolygon) {
				this.draftPolygon.setMap(null);
				this.draftPolygon = null;
			}
			if (clearMode) this.drawingMode = null;
			if (this.map) {
				this.map.setOptions({
					draggableCursor: null,
					disableDoubleClickZoom: false,
				});
			}
		},
		onMapClick(event) {
			if (this.noEdit || !this.drawingMode) return;

			if (this.drawingMode === "marker") {
				this.setSupplyMarker(event.latLng);
				this.startPolygon();
				return;
			}

			if (this.drawingMode === "polygon") {
				this.draftPath.push(this.toLatLngLiteral(event.latLng));
				this.updateDraftPolygon(this.draftPath);
			}
		},
		onMapMouseMove(event) {
			if (
				this.noEdit ||
				this.drawingMode !== "polygon" ||
				this.draftPath.length === 0
			) {
				return;
			}

			this.updateDraftPolygon([
				...this.draftPath,
				this.toLatLngLiteral(event.latLng),
			]);
		},
		setSupplyMarker(latLng) {
			const pos = {
				latitud: latLng.lat(),
				longitud: latLng.lng(),
			};
			this.$emit("changePosition", pos);

			if (this.prevMarker) this.prevMarker.setMap(null);
			this.prevMarker = new this.google.maps.Marker({
				position: latLng,
				map: this.map,
				title: "Marcador suministro",
			});
		},
		updateDraftPolygon(path) {
			if (!this.draftPolygon) {
				this.draftPolygon = new this.google.maps.Polygon({
					paths: path,
					map: this.map,
					clickable: false,
					editable: false,
					strokeColor: this.activeColor,
					fillColor: this.activeColor,
					strokeOpacity: 1,
					strokeWeight: 2,
					fillOpacity: 0.25,
				});
				return;
			}

			this.draftPolygon.setPath(path);
		},
		completePolygon() {
			if (this.draftPath.length < 3) return;

			const polygon = new this.google.maps.Polygon({
				paths: this.draftPath,
				map: this.map,
				clickable: true,
				draggable: false,
				editable: true,
				strokeColor: this.activeColor,
				fillColor: this.activeColor,
				strokeOpacity: 1,
				strokeWeight: 2,
				fillOpacity: 0.35,
			});
			polygon.visible = true;

			const cubierta = {
				color: this.activeColor,
				polygon,
				nombre: `Cubierta ${this.cubiertas.length + 1}`,
				center: this.getPolygonCenter(polygon),
				area: this.getPolygonArea(polygon),
				id: Math.random(),
			};

			this.attachPolygonListeners(cubierta);
			this.cubiertas.push(cubierta);
			this.$emit("input", this.cubiertas);
			this.cancelDrawing(false);
			this.startPolygon();
		},
		toLatLngLiteral(latLng) {
			return {
				lat: latLng.lat(),
				lng: latLng.lng(),
			};
		},
		getPolygonPath(polygon) {
			return polygon.getPath().getArray();
		},
		getPolygonArea(polygon) {
			const coords = this.getPolygonPath(polygon);
			return `${parseFloat(
				this.google.maps.geometry.spherical.computeArea(coords)
			).toFixed(3)} m2`;
		},
		getPolygonCenter(polygon) {
			const center = this.getPolygonPath(polygon).map((p) => [p.lat(), p.lng()]);
			const x = center.map((xy) => xy[0]);
			const y = center.map((xy) => xy[1]);
			return {
				lat: (Math.min(...x) + Math.max(...x)) / 2,
				lng: (Math.min(...y) + Math.max(...y)) / 2,
			};
		},
		refreshPolygonMetrics(cubierta) {
			cubierta.center = this.getPolygonCenter(cubierta.polygon);
			cubierta.area = this.getPolygonArea(cubierta.polygon);
			this.$emit("input", this.cubiertas);
		},
		attachPolygonListeners(cubierta) {
			if (cubierta._mapEventsAttached || !cubierta.polygon) return;

			const path = cubierta.polygon.getPath();
			["set_at", "insert_at", "remove_at"].forEach((eventName) => {
				path.addListener(eventName, () => this.refreshPolygonMetrics(cubierta));
			});
			cubierta._mapEventsAttached = true;
		},
		ensurePolygonRecord(p) {
			if (Array.isArray(p.polygon)) {
				p.polygon = new this.google.maps.Polygon({
					paths: p.polygon,
					strokeColor: p.color,
					fillColor: p.color,
					strokeOpacity: 1,
					strokeWeight: 2,
					fillOpacity: 0.35,
					editable: !this.noEdit,
				});
			}

			if (p.polygon.visible === undefined) p.polygon.visible = true;
			p.polygon.setVisible(p.polygon.visible !== false);
			p.polygon.setOptions({ editable: !this.noEdit });
			p.polygon.setMap(this.map);
			p.center = this.getPolygonCenter(p.polygon);
			p.area = this.getPolygonArea(p.polygon);
			this.attachPolygonListeners(p);
		},
	},
	watch: {
		center: {
			handler(n) {
				try {
					this.map.panTo(n);
				} catch { }
			},
			deep: true,
		},
		zoom: {
			handler(n) {
				try {
					this.map.setZoom(n);
				} catch { }
			},
			deep: true,
		},
		cubiertas: {
			handler(newVal) {
				newVal.forEach((p) => {
					this.ensurePolygonRecord(p);
				});
			},
			immediate: false,
		},
	},
};
</script>

<style lang="scss" scoped>
#map_container {
	height: 100%;
	position: relative;
	#map {
		height: 100%;
	}
}

.map-toolbar {
	position: absolute;
	z-index: 1;
	top: 10px;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: 8px;
	max-width: calc(100% - 20px);
}
</style>
